export const STORM = {
  path: '/storm',
  name: 'storm',
  redirect: '/storm-drzzle-accounts',
  component: require('@storm/').default,
  children: [
    {
      path: '/storm-global',
      name: 'storm-global',
      component: require('@storm/pages/').default,
      children: [
        {
          path: '/storm-drzzle-accounts',
          name: 'storm-drzzle-accounts',
          component: require('@storm/pages/drzzle-accounts/').default,
        },
        {
          path: '/storm-tickets',
          name: 'storm-tickets',
          component: require('@storm/pages/tickets/').default,
          children: [
            {
              path: '/storm-tickets/view/:id',
              name: 'storm-tickets-view',
              component: require('@storm/pages/tickets/view').default,
            },
          ],
        },
        {
          path: '/storm-analytics',
          name: 'storm-analytics',
          component: require('@storm/pages/user-analytics/').default,
        },
      ],
    },
    {
      path: '/storm-login',
      name: 'storm-login',
      component: require('@storm/login/').default,
    },
  ],
};

export const STORM_REDIRECT = {
  path: '*',
  redirect: '/storm-drzzle-accounts',
};



// WEBPACK FOOTER //
// ./src/storm/routes.js